import { markText, sub } from '@patsnap-utils/highlight';
import { isArray, forEach, map, upperFirst } from 'lodash';

export default {
    data() {
        return {
            higlightMixin_count: -1,
        };
    },
    created() {
        this.unsub = sub(() => {
            this.higlightMixin_count = this.higlightMixin_count + 1;
        });
    },
    destroyed() {
        this.unsub();
    },
    methods: {
        highlightMixin_hlText(value) {
            return markText(value, this.higlightMixin_count);
        },
    },
};

/**
 * 对 vue 组件指定 data 进行高亮，将结果应用到新生成的 data 配置项上
 *
 * @param {string} dataName vue 组件 data 属性的 name
*  @param  {Array}  dataName  List,创建多个高亮变量
 *
 * @param {string} hlDataName 生成的被高亮后 data 属性的 name. 默认为 `hl${upperFirst(dataName)}`
 * @returns {Object}
 */
export const markVueData = (dataName, hlDataName) => {
    let allData = {};
    let allWatch = {};
    let allHighlightConfig = [];
    if (isArray(dataName)) {
        allHighlightConfig = map(dataName, iName => {
            const autoHighlightDataName = `hl${upperFirst(iName)}`;
            const watchDataName = iName;
            allData[autoHighlightDataName] = '';
            allWatch[watchDataName] = function() {
                this.markVueDataMixin_hl();
            };
            return {
                watchDataName,
                autoHighlightDataName
            };
        });
    } else {
        const autoHighlightDataName = hlDataName || `hl${upperFirst(dataName)}`;
        const watchDataName = dataName;
        allData[autoHighlightDataName] = '';
        allWatch[watchDataName] = function() {
            this.markVueDataMixin_hl();
        };
        allHighlightConfig = [{
            watchDataName,
            autoHighlightDataName
        }];
    }
    return {
        data() {
            return {
                ...allData
            };
        },
        watch: {
            ...allWatch
        },
        created() {
            this.unsub = sub(this.markVueDataMixin_hl);
        },
        destroyed() {
            this.unsub();
        },
        methods: {
            markVueDataMixin_hl() {
                forEach(allHighlightConfig, ({ watchDataName, autoHighlightDataName }) => {
                    this[autoHighlightDataName] = markText(this[watchDataName]);
                });
            }
        }
    };
};
